/*
 * PatientData Messages
 *
 * This contains all the text for the PatientData container.
 */

import { defineMessages } from "react-intl";

export const scope = "app.containers.DentistData";

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: "Dentist",
  },

  deleteDentist: {
    id: `${scope}.deleteDentist`,
    defaultMessage: "Are you sure you want to delete this dentist?",
  },
});
